import React from 'react';
import InfoTooltip from 'shared/components/info-tooltip';
import Fieldset from 'shared/components/fieldset';
import RadioButton from 'src/components/radio-button';
import {GENDER_OPTIONS} from 'shared/utils';
import FormikRadioButtons from 'src/components/formik-radio-buttons';
import {useField} from 'formik';
import FormikTypeahead from 'src/components/formik-typeahead';

const GenderInput = () => {
  const [gender, , genderHelpers] = useField('gender');
  const [, , customGenderIdentityHelpers] = useField('customGenderIdentity');

  return (
    <Fieldset>
      <Fieldset.Legend>
        With what gender do you most closely identify?
        <InfoTooltip>
          Some scholarships are only available to students of a certain gender. Remember your
          responses are visible to colleges you Follow, your connected educators, and parents.
        </InfoTooltip>
      </Fieldset.Legend>

      <FormikRadioButtons
        name="gender"
        options={[
          {value: 'F', label: 'Female'},
          {value: 'M', label: 'Male'},
          {
            value: 'NB',
            label: 'Non-binary (describe in your own words)',
          },
        ]}
      ></FormikRadioButtons>
      {gender.value === 'NB' && (
        <FormikTypeahead
          id="gender-nb-typeahead"
          name="customGenderIdentity"
          allowNew
          options={GENDER_OPTIONS.map((option) => ({text: option, value: option}))}
          placeholder="Describe your gender"
          className="mt-12"
          onSelect={(value) => {
            customGenderIdentityHelpers.setValue(value.text);
          }}
        />
      )}
      <RadioButton
        label="Prefer not to answer"
        value="Prefer Not to Answer"
        onChange={() => genderHelpers.setValue('Prefer Not to Answer')}
        checked={gender.value === 'Prefer Not to Answer'}
        name="gender"
        className="mt-12"
      />
    </Fieldset>
  );
};

export default GenderInput;
